export default "__VITE_ASSET__DYjlse37__"